export default function getSearchString(code: ProductNumber | undefined) {
  if (code === '7') {
    return '?cons=true';
  }

  return '';
}
